var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRotate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.004 3.383a8.7 8.7 0 0 1 7.301 3.966V5.683a.7.7 0 1 1 1.4 0v2.72a1.18 1.18 0 0 1-1.18 1.18h-2.72a.7.7 0 1 1 0-1.4h1.372a7.302 7.302 0 0 0-13.437 3.17.7.7 0 0 1-1.393-.139 8.7 8.7 0 0 1 8.657-7.83M20.074 12.187a.7.7 0 0 1 .628.765 8.7 8.7 0 0 1-15.958 3.865v1.666a.7.7 0 1 1-1.4 0v-2.72a1.18 1.18 0 0 1 1.18-1.18h2.7199999999999998a.7.7 0 1 1 0 1.4H5.872a7.3 7.3 0 0 0 13.436-3.17.7.7 0 0 1 .766-.626"
})));
export default SvgArrowRotate;